// extracted by mini-css-extract-plugin
export default {"link":"FoldedComments-module__link--iMe15"};